import logo from "./logo.png";
import './index.css';
import {
  BrowserRouter as Router,
  Link
} from "react-router-dom";

function Header(props) {
  return (
    <header className="row">
      <div className="col-md-5">
        <img src={logo} className="logo" alt="logo" />
      </div>
      <form className="ui form">
        <div className="equal width fields">
          <div className="field">
            <Link to="/transactions">Transactions</Link>
          </div>
          <div className="field">
            <Link to="/qboids">Qboid</Link>
          </div>
          <div className="field">
            <Link to="/connections">Connection</Link>
          </div>
          <div className="field">
            <Link to="/setups">Transaction Setup</Link>
          </div>
        </div>
      </form>
    </header>
  );
}

export default Header;